import Icon from '../components/Icon.vue'

Icon.register({
  'hand-spock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M10.9 316.6C26 300.5 51.3 299.7 67.4 314.9L128 371.9V292.5L89 120.9C84.1 99.3 97.6 77.9 119.1 73 140.7 68.1 162.1 81.6 167 103.1L201.7 256H211.6L164 49C159.1 27.4 172.5 6 194 1 215.6-3.9 237 9.5 242 31.1L293.7 256H308.8L357.2 62.3C362.6 40.9 384.3 27.8 405.7 33.2 427.1 38.6 440.2 60.3 434.8 81.7L391.2 256H402.3L433.1 126.7C438.2 105.2 459.8 92 481.3 97.1 502.7 102.2 516 123.8 510.9 145.3L474.6 297.7A96-96 0 0 1 472 320V362.1A96-96 0 0 0 468 389.4L441.9 477.6C435.8 498 417.1 512 395.8 512H179.2A48-48 0 0 0 146.3 499L12.6 373.1C-3.5 358-4.3 332.7 10.9 316.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-spock.js
// module id = oWko
// module chunks = 144